import { useLocale } from '@mirai/locale';
import { styles, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import { GooglePay } from './components/GooglePay';
import { L10N } from './FormAddon.l10n';
import * as style from './FormAddon.module.css';
import { getCtaKey } from './helpers';
import { loadScript } from '../../helpers/loadScript';

const BUTTON = 'addonInitButton';
const IFRAME = 'addonIframe';

export const FormAddon = ({ info: { amount, date } = {}, method, provider, response, ...others }) => {
  const { translate } = useLocale();

  const el = useRef();

  const [googlePayId, setGooglePayId] = useState(false);
  const [ready, setReady] = useState();

  useEffect(() => {
    setGooglePayId();
    return loadScript({ id: 'addonScript', name: 'rxp-hpp.js', onLoad: handleLoad });
  }, []);

  useEffect(() => {
    if (!response || !ready) return;

    const { configuration: { GOOGLE_PAY_ID, RETURN_URL: responseUrl, ...configuration } = response } = response || {};

    setGooglePayId(GOOGLE_PAY_ID);

    window.RealexHpp?.setHppUrl(configuration.ACTION_URL || process.env.PROVIDER_ADDON_SCRIPT);
    window.RealexHpp?.embedded.init(BUTTON, IFRAME, responseUrl, {
      ...configuration,
      CARD_PAYMENT_BUTTON: translate(getCtaKey(date, method, provider)),
    });
    el.current?.click();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, response]);

  const handleLoad = () => setReady(true);

  return (
    <View {...others} className={styles(others.className, style.container)}>
      {googlePayId && <GooglePay {...{ amount, googlePayId, response, ...others }} />}
      <input hidden id={BUTTON} ref={el} type="submit" />
      <iframe id={IFRAME} title={translate(L10N.LABEL_SECURE_PAGE)} className={style.iframe} />
    </View>
  );
};

FormAddon.displayName = 'Mirai:Payments:ButtonPayment:FormAddon';

FormAddon.propTypes = {
  info: PropTypes.shape({
    cardValidation: PropTypes.bool,
    date: PropTypes.instanceOf(Date),
    amount: PropTypes.number,
  }),
  method: PropTypes.string,
  provider: PropTypes.string,
  response: PropTypes.object,
};
